import PsikotestSystemLayout from "./PsikotestSystemLayout";

function PsikotestSystemApp() {
  return <PsikotestSystemLayout />;
}

export default PsikotestSystemApp;
